module.exports = __webpack_public_path__ + "static/bed-frame-4-8bb863bd58c5366d0dcb7de821e208e5.webp";